<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/HOTSPOT BANJIR.png"
        alt="HOTSPOT BANJIR"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>HOTSPOT BANJIR</h2>
      <div class="banjir">
        <!-- First Image -->
        <div class="banjir-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Bilangan Hotspot Banjir Kilat di Kawasan PBT</h3>
              <p class="number">
                {{ totalHotspotBanjir }}
              </p>
            </div>
          </div>
        </div>
      </div>

      
      
   
      <PrimaryModule />
      <KejuruteraanKesihatanMenu />  
    </div>
    <div class="content-wrapper">
      <h2>LOKASI HOTSPOT BANJIR DI KAWASAN PBT</h2>
      <MapHotspotBanjir />
    </div>
  </adminbackground>
</template>


<script setup>
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

// const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])

// const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const totalHotspotBanjir = ref(null)



const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi(state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {

    // Ensure we're working with a plain array for states
    const plainStates = toRaw(state)

    // Create query parameters for year and states
    // Create the query parameters manually
    let queryParams = "" 

    // console.log('Plain states:', plainStates)

    // Check if states are "Semua Negeri" and skip appending states[] if true
    if (!plainStates.includes("Semua Negeri")) {
      // Append each state to the query string with the desired 'states[]' format
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    // Append councils[] if pbtValue is selected
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      // Append each PBT in the array to the query parameters
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // Construct the URL with the query parameters
    const url = `kejuruteraan-kesihatan-umum/hotspot-banjir?${queryParams}`

    const response = await httpGet(url)

    // years.value = response.years

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    totalHotspotBanjir.value = response.data.bilangan_banjir_total

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}


onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([ selectedsState, selectedPbt], () => {
  loadDataFromApi( selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px; 
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


.banjir {
  display: flex;
  justify-content: flex-start; /* Align the image to the left */
  align-items: center;
}

.banjir-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  max-width: 500px; /* Set a fixed width */
  margin-right: 20px; /* Add some spacing to the right */
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

/* Styles for large screens (1024px and up) */
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
    max-width: 1000px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px; 
  }

  .banjir {
    flex-direction: column; 
    align-items: center; 
  }

  .banjir-container {
    max-width: 500px; 
    margin-bottom: 20px; 
  }

  h2 {
    font-size: 1.3rem;
    text-align: left;
  }
}

/* Styles for medium screens (768px and below) */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
    max-width: 700px;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .banjir {
    flex-direction: column;
    align-items: center;
  }

  .banjir-container {
    max-width: 450px;

  }

  h2 {
    font-size: 1.2rem;
    text-align: left;
  }

  .text-overlay .values-layered h3 {
    font-size: 16px; /* Reduces font size for better fit */
  }

  .number {
    font-size: 22px;
  }
}

/* Styles for small screens (480px and below) */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
    max-width: 100%;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .banjir-container {
    max-width: 100%; /* Makes container responsive to screen width */
    margin-bottom: 15px;
  }

  .text-overlay .values-layered h3 {
    font-size: 14px; /* Smaller font size for smaller screens */
    line-height: 1.2; /* Adjusts line height for readability */
  }

  .number {
    font-size: 20px;
  }

  h2 {
    font-size: 1rem;
    text-align: left;
  }

  .pbt-image {
    max-width: 70%; /* Reduces the image size for better fit */
  }

  .line-under-image {
    width: 70%; /* Matches the width of the image */
  }
}
</style>
